import { render, staticRenderFns } from "./Intro2.vue?vue&type=template&id=13149391&scoped=true"
import script from "./Intro2.vue?vue&type=script&lang=js"
export * from "./Intro2.vue?vue&type=script&lang=js"
import style0 from "./Intro2.vue?vue&type=style&index=0&id=13149391&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13149391",
  null
  
)

export default component.exports